<div class="row">
  <div class="row hdrBar">
    <div class="col-lg-12 col-md-12 mg-a">
      <h1>Vehicle ULB assignment</h1>
    </div>
  </div>
</div>
<div class="fltrbg">
  <div class="row">
    @if (ShowClap) {
    <div class="col-lg-2 col-md-2 crdCl">
      <p class="slctlbl">Vehicle Vendor</p>
      <nz-select
        class="slctBx"
        nzShowSearch
        [(ngModel)]="selectedvndr"
        (ngModelChange)="onvndrSelect($event)"
        [ngModelOptions]="{ standalone: true }"
      >
        @if (!showVndr) {
        <nz-option [nzLabel]="'All'" [nzValue]="0"></nz-option>
        } @for (v of vendorList; track v) {
        <nz-option [nzValue]="v.vndr_id" [nzLabel]="v.vndr_nm"></nz-option>
        }
      </nz-select>
    </div>
    }
  </div>
</div>
<div style="padding: 0px 10px">
  <div class="ds-card grid tbl dwntbl vhclsCmpnt">
    <app-data-grid
      class="p-8"
      style="width: 100%"
      [dataSource]="vhcleslst"
      [legacyColumns]="vhclslstcolumnDefs"
      [searchPanel]="true"
      [filterRow]="false"
      [filterPanel]="false"
      [groupPanel]="true"
      [columnChooser]="true"
      [allowExport]="true"
      exportFileName="SS assigned Vehicles Data"
      [pageSize]="10"
      [allowedPageSizes]="[10, 25, 50, 100]"
      [showPageSizeSelector]="true"
      [rowAlternationEnabled]="true"
      [showBorders]="true"
    >
      <app-grid-column
        [showInColumnChooser]="false"
        [visible]="true"
        type="buttons"
        [width]="100"
        caption="change ULB"
        cellTemplate="editTemplate"
      ></app-grid-column>
      <ng-template appGridCell="editTemplate" let-data="cell"
        ><div>
          <div class="tblEdtBtn" (click)="openSlider(data)">
            <i nz-icon nzType="car" nzTheme="outline"></i>
          </div></div
      ></ng-template>
    </app-data-grid>
  </div>
</div>
<nz-drawer
  [nzBodyStyle]="{ overflow: 'auto' }"
  [nzMaskClosable]="false"
  [nzWidth]="500"
  [nzVisible]="opensldr"
  nzTitle="Change ULB"
  (nzOnClose)="closeSideBar()"
>
  <ng-container *nzDrawerContent>
    <form nz-form class="drvrDtlsfrm">
      <div nz-row [nzGutter]="8">
        <div nz-col nzSpan="24">
          <nz-form-label>Vehicle</nz-form-label>
          <nz-form-item>
            <nz-form-control>
              <nz-select
                nzShowSearch
                nzAllowClear
                nzPlaceHolder="Select Vehicle"
                [(ngModel)]="asrt_id"
                [ngModelOptions]="{ standalone: true }"
                nzDisabled
              >
                @for (v of asrtList; track v) {
                <nz-option
                  [nzLabel]="v.asrt_nm"
                  [nzValue]="v.asrt_id"
                ></nz-option>
                }
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col nzSpan="24">
          <nz-form-label>ULB</nz-form-label>
          <nz-form-item>
            <nz-form-control>
              <nz-select
                class="slctBx"
                nzShowSearch
                [(ngModel)]="tnt_id"
                (ngModelChange)="ontntSelect($event)"
                [ngModelOptions]="{ standalone: true }"
                nzPlaceHolder="Select ULB to be changed"
              >
                @for (t of tntLst; track t) {
                <nz-option
                  [nzValue]="t.tnt_id"
                  [nzLabel]="t.tnt_nm"
                ></nz-option>
                }
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col nzSpan="24">
          <nz-form-label>Vehicle Category</nz-form-label>
          <nz-form-item>
            <nz-form-control>
              <nz-select
                class="slctBx"
                nzShowSearch
                [(ngModel)]="asrt_ctgry_id"
                (ngModelChange)="onctgrySelect($event)"
                [ngModelOptions]="{ standalone: true }"
                nzPlaceHolder="Select Vehicle Category"
              >
                @for (v of vehctgryLst; track v) {
                <nz-option
                  [nzValue]="v.asrt_ctgry_id"
                  [nzLabel]="v.asrt_ctgry_nm"
                >
                </nz-option>
                }
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col nzSpan="24">
          <nz-form-label>Vehicle Group</nz-form-label>
          <nz-form-item>
            <nz-form-control>
              <nz-select
                class="slctBx"
                nzShowSearch
                [(ngModel)]="asrt_grp_id"
                (ngModelChange)="onvehGrpSelect($event)"
                [ngModelOptions]="{ standalone: true }"
                nzPlaceHolder="Select Vehicle Group"
              >
                @for (v of vhcleGrp; track v) {
                <nz-option
                  [nzValue]="v.asrt_grp_id"
                  [nzLabel]="v.asrt_grp_nm"
                ></nz-option>
                }
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col nzSpan="24">
          <nz-form-label>Vehicle Status</nz-form-label>
          <nz-form-item>
            <nz-form-control>
              <nz-select
                class="slctBx"
                nzShowSearch
                [(ngModel)]="asrt_sts_id"
                (ngModelChange)="onstatusChange($event)"
                [ngModelOptions]="{ standalone: true }"
                nzPlaceHolder="Select Vehicle Status"
              >
                @for (v of vehicleSts; track v) {
                <nz-option
                  [nzValue]="v.asrt_sts_id"
                  [nzLabel]="v.asrt_sts_nm"
                ></nz-option>
                }
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
    </form>

    <div class="btngrp">
      <button
        nz-button
        style="margin-right: 8px"
        (click)="closeSideBar()"
        nzType="primary"
        nzDanger
      >
        Cancel
      </button>
      <button nz-button (click)="saveasgnmnt()" class="sbmtbtn">
        Change ULB
      </button>
    </div>
  </ng-container>
</nz-drawer>
@if (showLdr) {
<ds-loading></ds-loading>
}
